import { withStyles, AppBar } from '@eGroupTeam/material';

export default withStyles(() => ({
  root: {
    background: 'transparent',
    boxShadow: 'none',
  },
}))(AppBar);
